import React from "react";
import Chunk from "./Chunk";

const TwoColumnContent = props => {
  return (
    <>
      {props.columns !== null &&
        <div className="columns is-variable is-8 has-text-centered">
          <div className="column is-6">
            {props.columns.columnOne !== null &&
              <Chunk
                chunk={props.columns.columnOne.chunk}
                langKey={props.langKey}
                reusable={props.reusable}
              />
            }
          </div>

          <div className="column is-6">
            {props.columns.columnTwo !== null &&
              <Chunk
                chunk={props.columns.columnTwo.chunk}
                langKey={props.langKey}
                reusable={props.reusable}
              />
            }
          </div>
        </div>
      }
    </>
  );
};

export default TwoColumnContent